import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

// redux create api logic
interface CmsItem {
    id: number;
    name: string;
    type: number;
    value: string;
}

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: '<api_url>',
        prepareHeaders(headers) {
            headers.set('x-api-key', 'jfkdlsajfdl;');
            return headers;
        },
    }),
    tagTypes: ['Post', 'Put', 'Get', 'Fetch'],
    endpoints(builder) {
        return {
            fetchPublicCmsItems: builder.query<CmsItem[], number | void>({
                query(limit = 10) {
                    return `/getCmsItems?limit=${limit}`;
                },
            }),
            fetchUserIcon: builder.query<string, number | void>({
                query(limit = 10) {
                    return `/getUserIcon?limit=${limit}`;
                },
            }),
        };
    },
});

export const {useFetchPublicCmsItemsQuery, useFetchUserIconQuery} = apiSlice;
